import axios from 'axios';
import { datadogRum } from '@datadog/browser-rum';
import { CACHE_KEY_PREFIX, CACHE_KEY_USER_SUFFIX, COOKIES_KEY_PREFIX } from '../../constants';
import type { AuthObject } from '@white-label-types/auth';
import type { Context } from '@white-label-types/global-context';

export const fetchUserWrapper = async (
    token: string,
    app: Context['app'],
    authInstance: AuthObject
) => {
  try {
    const response = await axios.get(`https://${authInstance.domain}/userinfo`, {
      headers: {
        Authorization: token,
      },
    });
    const userResponse = response.data;
    const userStorageKey = `${CACHE_KEY_PREFIX}::${authInstance.clientId}::${CACHE_KEY_USER_SUFFIX}`;
    const tokenNoBearer = token.replace('Bearer ', '');

    const userData = {
      decodedToken: {
        user: userResponse
      },
      id_token: tokenNoBearer,
    }

    localStorage.setItem(userStorageKey, JSON.stringify(userData));
    await authInstance.refreshUser();
  } catch (error) {
    const errorContext = {
      file: 'white-label-plugin > auth.ts > fetchUser()',
      domain: authInstance.domain || '',
      token: app['$cookies'].get(`${COOKIES_KEY_PREFIX}.${authInstance.clientId}.token`) || ''
    }
    console.error('Datadog error logged - fetchUser', errorContext)
    datadogRum.addError(
      new Error('Auth fetchUser:', { cause: error }),
      errorContext
    );
  }
}
